import { Injectable, Signal, WritableSignal, computed, inject, signal } from "@angular/core";
import { IQueueLocation, QueueLayoutAbstraction } from "@shared-core/general/queue/abstractions/queue-layout.abstraction";
import { AuthService } from "@app/shared/auth/services/auth.service";

/**
 * Customer-kiosk implementation of {@link QueueLayoutAbstraction}.
 *
 * The kiosk's current location comes from the verified guest session, so this
 * adapter maps `AuthService.location` ({ id, locationName }) onto the neutral
 * { id, name } shape the shared queue footer expects. No customer page contributes
 * a fullscreen guard, so `fullscreenToggle` stays empty here.
 */
@Injectable()
export class QueueLayoutService implements QueueLayoutAbstraction {
  private readonly authService = inject(AuthService);

  readonly location: Signal<IQueueLocation | null> = computed(() => {
    const loc = this.authService.location();
    return loc ? { id: loc.id, name: loc.locationName } : null;
  });

  readonly fullscreenToggle: WritableSignal<(() => void) | null> = signal(null);
}
